

exports.__esModule = true;

var _squid = require('squid');

require('xo-ui-components/src/directionality/directive');

require('components/xo-ui-components/src/error-tooltip/directive');

require('components/xo-validation/dist/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoEmailInput', {
    tag: 'xo-email-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: 'true'
        },
        disabled: {
            type: 'var',
            required: 'false'
        },
        hideHelper: {
            type: 'var', // flow: Optional string, if "signup" then use the Signup tooltip
            required: 'false'
        },
        flags: {
            type: 'var',
            required: 'false'
        }
    },
    lifecycle: {
        enter: function enter() {
            this.flags = this.flags ? this.flags : {};
        }
    }
});


_squid.$Component;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/emailInput/directive.js
// module id = ./components/xo-guest-components/src/guest/emailInput/directive.js
// module chunks = 1